export default "__VITE_ASSET__ff55429d__"